export default __webpack_public_path__ + "static/media/g10.b7672ebb.svg";